import React from 'react';

const Training = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Training</h1>
        <p>Project Development & Financing Training Programs</p>
      </section>
      <section className="page-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-card">
              <h2>Upcoming Training</h2>
              <button className="btn-gold" onClick={() => window.location.href='/upcoming-training'}>View Upcoming</button>
            </div>
            <div className="content-card">
              <h2>Past Training</h2>
              <button className="btn-gold" onClick={() => window.location.href='/past-training'}>View Past</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Training;